import {Payload} from './payload';

export class PayloadV2 implements Payload {
    id: string | number;
}
